export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1713_.249093bb.jpg";